import { Flex, Skeleton, Space } from '@mantine/core';

const AddIdentitySkeleton = () => {
  return (
    <>
      <Skeleton height={30} width={100} radius="md" />
      <Space h="md" />
      <Skeleton height={70} width={500} radius="lg" />
      <Space h="lg" />

      <Skeleton height={30} width={100} radius="md" />
      <Space h="md" />
      <Skeleton height={70} width={500} radius="lg" />
      <Space h="md" />

      <Skeleton height={30} width={300} radius="md" />
      <Space h="md" />
      <Skeleton height={30} width={500} radius="lg" />
      <Space h="sm" />
      <Skeleton height={30} width={500} radius="lg" />
      <Space h="md" />

      <Skeleton height={30} width={100} radius="md" />
      <Space h="md" />
      <Skeleton height={70} width={500} radius="lg" />
      <Space h="md" />

      <Flex direction={'row'} gap={5}>
        <Skeleton height={30} width={150} radius="lg" />
        <Skeleton height={30} width={80} radius="lg" />
      </Flex>
    </>
  );
};

export default AddIdentitySkeleton;
